import request from 'superagent';

import * as types from 'constants/ActionTypes';
import { GRAPHDATA_URL } from 'constants/Jaws';
import doubleEncode from 'utils/doubleEncode';

function requestData(itemSector) {
  return {
    type: types.SPARKLINE_REQUEST_DATA,
    itemSector,
  };
}

function receiveData(itemSector, data) {
  return {
    type: types.SPARKLINE_RECEIVE_DATA,
    itemSector,
    data,
  };
}

export function fetchData(itemSector) {
  return (dispatch, getState) => {
    const existing = getState().sparklines.get(itemSector);
    if (existing == null) {
      dispatch({ type: types.SPARKLINE_CREATE, itemSector });
    }
    dispatch(requestData(itemSector));
    return request
      .get(`${GRAPHDATA_URL}/s1/tick/${doubleEncode(itemSector)}`)
      .query({ points: 50 })
      .end((err, res) => {
        if (err) return; //throw new Error(err);

        const data = res.body.rows[0].values.series.s1.data;
        dispatch(receiveData(itemSector, data));
      });
  };
}
